import { get, post } from '../utils/request';

// 保存聊天信息
export const saveMessageInfo = (params:any) => {
  return post<any>('/chat/save_message',params);
};

// 获取聊天室联系人列表
export const getChatRoomList = () => {
  return get<any>('/chat/get_chat_room_list');
};


// 获取聊天内容列表详情
export const getChatDetailList = (data:any) => {
  return get<any>('/chat/get_messages_by_room_id',data);
}; 


// 创建会话列表
export const createChatRoom = (params:any) => {
  return post<any>('/chat/create_chat_room',params);
};


// 获取未读消息数量
export const getNotReadMessageNum = () => {
  return get<any>('/chat/get_not_read_message_num');
};


// 把聊天信息变成已读
export const saveMessageStatus = (params:any) => {
  return post<any>('/chat/save_message_status',params);
};



// cart/save_manage_cart
// {
//   "product_list":[
//       {
//           "product_id":"PROD-71ba237aef511753068329140",
//           "product_sku_id":"sku9079849108409807",
//           "quantity":2,
//       }
//   ]
// }